import React from "react";

const colorClasses = {
  green: "tw-bg-green-100 tw-text-green-800 tw-border-green-300",
  blue: "tw-bg-blue-100 tw-text-blue-800 tw-border-blue-300",
  red: "tw-bg-red-100 tw-text-red-800 tw-border-red-300",
  yellow: "tw-bg-yellow-100 tw-text-yellow-800 tw-border-yellow-300",
  violet: "tw-bg-violet-100 tw-text-violet-800 tw-border-violet-300",
  amber: "tw-bg-amber-100 tw-text-amber-800 tw-border-amber-300",
  gray: "tw-bg-gray-100 tw-text-gray-800 tw-border-gray-300",
} as const;

export type StatusBadgeColor = keyof typeof colorClasses;

type BalloonPos =
  | "up"
  | "down"
  | "left"
  | "right"
  | "up-left"
  | "up-right"
  | "down-left"
  | "down-right";

type Props = {
  label: React.ReactNode;
  color: StatusBadgeColor;
  tooltip?: string;
  tooltipPos?: BalloonPos;
};

export const StatusBadge: React.FC<Props> = ({
  label,
  color,
  tooltip,
  tooltipPos = "up",
}) => {
  const tooltipProps = tooltip
    ? { "data-balloon": tooltip, "data-balloon-pos": tooltipPos }
    : {};

  return (
    <span
      className={`tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-border tw-whitespace-nowrap ${colorClasses[color]}`}
      {...tooltipProps}
    >
      {label}
    </span>
  );
};
